import { createSlice } from '@reduxjs/toolkit';
import {
  ApplicationState,
  TosUpdatedDates,
  TosUpdatedDatesStatus,
} from './types';
import { INITIAL_STATE } from './state';
import {
  retrieveTosNextUpdateDates,
  retrieveTosUpdateDates,
} from './asyncActions';

const initialState: ApplicationState = INITIAL_STATE;

// Example of listening to legacy action
// const legacyStyleReducerSucceedAction = createAction(
//   'FETCH_HOME_PAGE_DATA_SUCCESS'
// );

export const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // retrieveTosUpdateDates
      .addCase(retrieveTosUpdateDates.pending, (state) => {
        state.tosUpdatedDates = {
          status: TosUpdatedDatesStatus.Loading,
          dates: null,
        };
      })
      .addCase(retrieveTosUpdateDates.fulfilled, (state, action) => {
        const tosUpdatedDates: TosUpdatedDates | null = action.payload;

        state.tosUpdatedDates = {
          status: TosUpdatedDatesStatus.Loaded,
          dates: tosUpdatedDates,
        };
      })
      .addCase(retrieveTosUpdateDates.rejected, (state) => {
        state.tosUpdatedDates = {
          status: TosUpdatedDatesStatus.Error,
          dates: null,
        };
      })

      // retrieveTosNextUpdateDates
      .addCase(retrieveTosNextUpdateDates.pending, (state) => {
        state.tosNextUpdateDates = {
          status: TosUpdatedDatesStatus.Loading,
          dates: null,
        };
      })
      .addCase(retrieveTosNextUpdateDates.fulfilled, (state, action) => {
        const tosUpdatedDates: TosUpdatedDates | null = action.payload;

        state.tosNextUpdateDates = {
          status: TosUpdatedDatesStatus.Loaded,
          dates: tosUpdatedDates,
        };
      })
      .addCase(retrieveTosNextUpdateDates.rejected, (state) => {
        state.tosNextUpdateDates = {
          status: TosUpdatedDatesStatus.Error,
          dates: null,
        };
      });
    // Example of listing to legacy actions
    // .addCase(legacyStyleReducerSucceedAction, (state, action) => {
    //   console.log(
    //     state,
    //
    //     // Need to do some hacky type assertion here.
    //     // While you can define the type with createAction<...>, createAction
    //     // expect the payload data all inside of payload attribute
    //     // (e.g. action.payload.featuredCourses instead of action.featuredCourses)
    //     // which does not match our legacy action payload style.
    //     ((action as unknown) as FetchHomePageDataSuccessAction)
    //       .featuredCourses
    //   );
    // });
  },
});

export const Application = applicationSlice.reducer;
